import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";
import moment from "moment";

export interface DateRangeApi {
  range: ReadOnlyStore<{ start: string | null; end: string | null }>;
  setRange(start: string | null, end: string | null): void;
}

const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

// Default range: today, one week back (overridden by ?start/?end deep links).
function defaultRange(): { start: string; end: string } {
  return {
    start: moment().subtract(1, "week").startOf("day").format(DATE_FORMAT),
    end: moment().endOf("day").format(DATE_FORMAT),
  };
}

export function createDateRangeApi(): DateRangeApi {
  const store = createStore<{ start: string | null; end: string | null }>(
    defaultRange(),
  );
  return {
    range: store.store,
    setRange: (start, end) => store.set({ start, end }),
  };
}
